
export const AGE_LEVELS = [
  "Infant",
  "Age 1",
  "Age 2",
  "Age 3",
  "Age 4",
  "Age 5",
  "Age 6"
] as const;
